import React from 'react'

import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles, Paper, Typography } from '@material-ui/core'
import StandardFormButtonSet from '../../StandardFormButtonSet'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3),
  },
  progress: {
    margin: theme.spacing(2),
  },
  formPaper: {
    padding: theme.spacing(3, 2),
    marginBottom: 10,
  },
  fieldBase: {
    maxWidth: 300,
  },
  dropdownNumberBase: {
    maxWidth: 75,
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}))

const CustomerConfigFormFields = ({
  values,
  touched,
  errors,
  dirty,
  status,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  handleReset,
}) => {
  const classes = useStyles()
  return (
    <form onSubmit={handleSubmit}>
      {values.components.map((component, componentIndex) => {
        if (!component.hasConfigurableParameters) {
          return (
            <div>
              <h1>
                {component.Component} {component.count}
              </h1>
              Component has no configurable parameters
            </div>
          )
        } else {
          return [
            <Paper className={classes.formPaper}>
              <Typography component="h1" variant="h4" gutterBottom>
                {component.ProductName} - {component.ComponentName}
              </Typography>
              {component.DocumentParameters.map((parameter, parameterIndex) => {
                let description = JSON.parse(parameter.Description)

                if (
                  // no description
                  !description ||
                  // or not editable
                  !description.editable ||
                  // or not external
                  !description.external
                ) {
                  return undefined
                }

                let currentError = ''

                let currentTouched = ''
                try {
                  if (
                    errors.components &&
                    errors.components[componentIndex] &&
                    errors.components[componentIndex].DocumentParameters &&
                    errors.components[componentIndex].DocumentParameters[parameterIndex] &&
                    errors.components[componentIndex].DocumentParameters[parameterIndex].value
                  ) {
                    currentError =
                      errors.components[componentIndex].DocumentParameters[parameterIndex].value
                  }
                } catch (ex) {
                  console.log(ex)
                }
                // need this value to map for formik
                let name = `components[${componentIndex}].DocumentParameters[${parameterIndex}].value`

                if (description.type === 'select') {
                  return (
                    <TextField
                      id={parameter.Name}
                      label={description.name}
                      margin="normal"
                      name={name}
                      onChange={handleChange}
                      select
                      value={parameter.value}
                      error={currentError}
                      fullWidth
                    >
                      {description.options.map((option, index) => (
                        <MenuItem key={`${option}-${index}`} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  )
                }
                return (
                  <TextField
                    type={description.type}
                    id={parameter.Name}
                    label={description.name}
                    margin="normal"
                    name={name}
                    value={parameter.value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={currentError && currentTouched}
                    error={currentError}
                    fullWidth
                  />
                )
              })}
            </Paper>,
          ]
        }
      })}
      <StandardFormButtonSet {...{ handleReset, dirty, isSubmitting, status }} />
    </form>
  )
}

export default CustomerConfigFormFields
